import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnDestroy,
  PLATFORM_ID,
} from '@angular/core';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-fade-component',
  templateUrl: './fade-component.component.html',
  styleUrl: './fade-component.component.scss',
  standalone: true,
  imports: [CommonModule],
})
export class FadeComponentComponent {
  @ViewChild('OmFadeElement') omFadeElement!: ElementRef<HTMLElement>;

  @Input() direction: 'up' | 'down' | 'left' | 'right' = 'up';
  @Input() animateOnlyOnce = false;
  @Input() transitionDuration: string = '500ms';
  @Input() transitionFunction: string = 'ease-in-out';
  @Input() stagger: number = 0; // Default no stagger effect

  inViewport = false;
  private observer!: IntersectionObserver;

  constructor(private readonly cdr: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.initObserver();
    this.applyStaggerEffect();
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private initObserver(): void {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.inViewport = true;
        this.cdr.detectChanges();
      } else if (!this.animateOnlyOnce) {
        this.inViewport = false;
        this.cdr.detectChanges();
      }
    });

    this.observer.observe(this.omFadeElement.nativeElement);
  }

  private applyStaggerEffect(): void {
    if (!this.omFadeElement) return;

    const children = this.omFadeElement.nativeElement.children;
    Array.from(children).forEach((child, index) => {
      const htmlChild = child as HTMLElement;
      const delay = index * this.stagger;
      htmlChild.style.transitionDelay = `${delay}ms`;
    });
  }
}
